"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var searchParamsSlice_1 = require("../../../../features/searchParams/searchParamsSlice");
var react_redux_1 = require("react-redux");
var BlDropdown_1 = __importDefault(require("../../BlDropdown"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var StateChoice = function (_a) {
    var defaultValue = _a.defaultValue, handleStateDistrictChange = _a.handleStateDistrictChange, currentLanguage = _a.currentLanguage;
    var t = react_i18next_1.useTranslation('common').t;
    var filterGroup = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var _b = react_1.useState([]), states = _b[0], setStates = _b[1];
    var _c = react_1.useState(), selectedState = _c[0], setSelectedState = _c[1];
    react_1.useEffect(function () {
        (filterGroup === null || filterGroup === void 0 ? void 0 : filterGroup.state) && setStates(filterGroup.state.options);
    }, [filterGroup]);
    react_1.useEffect(function () {
        if (defaultValue) {
            var selectedState_1 = states.find(function (item) { return String(item.govId) === defaultValue; });
            setSelectedState(selectedState_1);
        }
    }, [defaultValue, states]);
    react_1.useEffect(function () {
        if (selectedState) {
            handleStateDistrictChange(selectedState, 'stateId', 'state');
        }
    }, [selectedState]);
    var handleChange = function (data) {
        var selectedState = states.find(function (item) { return item.text === data.value; });
        setSelectedState(selectedState);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('field required', styles_module_scss_1.default.state) },
        react_1.default.createElement("label", { htmlFor: "state" }, t('fields.section3.state')),
        react_1.default.createElement(BlDropdown_1.default, { value: (selectedState === null || selectedState === void 0 ? void 0 : selectedState.text) || '', options: states.map(function (item) {
                var _a;
                return ({
                    key: item.govId,
                    value: item.text,
                    text: (_a = item.translations[currentLanguage]) !== null && _a !== void 0 ? _a : item.text,
                });
            }), selection: true, className: styles_module_scss_1.default.dropdown, placeholder: t('ADDRESS_PICKER.STATE'), name: "state", selectOnBlur: false, onChange: function (event, data) { return handleChange(data); } })));
};
exports.default = StateChoice;
